/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
//import { observer } from 'mobx-react';
import Chart from 'chart.js/auto';

class PieChart2 extends Component {
  constructor(props) {
    super(props);
    this.chart = null;
  }

  componentDidMount() {
    this.drawChart();
  }

  componentWillUnmount() {
    if (this.chart) {
      this.chart.destroy();
    }
  }

  drawChart() {
    const { translate } = this.props;
    if (this.chart) {
      this.chart.destroy();
      this.chart = null;
    }

    const count = this.props.chartData.languages.length;
    const LabelResult = [];
    const DataResult = [];

    if (count > 3) {
      let i = 0;
      let totalScore = 0;
      let highRankScore = 0;
      for (i; i < this.props.chartData.languages.length; i++) {
        totalScore += this.props.chartData.languages[i].percentage;
      }
      this.props.chartData.languages.map((item, index) => {
        if (index < 3) {
          LabelResult.push(item.language);
          DataResult.push(item.percentage);
          highRankScore += item.percentage;
        } else if (index === 3) {
          const othersScore = totalScore - highRankScore;
          if (othersScore > 0) {
            LabelResult.push(translate('contents_header.menu.others'));
            DataResult.push(othersScore);
          }
        }
        return null;
      });
    } else {
      this.props.chartData.languages.map((item) => {
        LabelResult.push(item.language);
        DataResult.push(item.percentage);
        return null;
      });
    }

    const getOrCreateTooltip = (chart) => {
      let tooltipEl = chart.canvas.parentNode.querySelector('div');

      if (!tooltipEl) {
        tooltipEl = document.createElement('div');
        tooltipEl.style.background = 'rgba(0, 0, 0, 0.7)';
        tooltipEl.style.borderRadius = '3px';
        tooltipEl.style.color = 'white';
        tooltipEl.style.opacity = 1;
        tooltipEl.style.pointerEvents = 'none';
        tooltipEl.style.position = 'absolute';
        tooltipEl.style.transform = 'translate(-50%, 0)';
        tooltipEl.style.transition = 'all .1s ease';

        const table = document.createElement('table');
        table.style.margin = '0px';

        tooltipEl.appendChild(table);
        chart.canvas.parentNode.appendChild(tooltipEl);
      }

      return tooltipEl;
    };

    const externalTooltipHandler = (context) => {
      // Tooltip Element
      const { chart, tooltip } = context;
      const tooltipEl = getOrCreateTooltip(chart);

      // Hide if no tooltip
      if (tooltip.opacity === 0) {
        tooltipEl.style.opacity = 0;
        return;
      }

      // Set Text
      if (tooltip.body) {
        const titleLines = tooltip.title || [];
        const bodyLines = tooltip.body.map((b) => { return b.lines; });

        const tableHead = document.createElement('thead');

        titleLines.forEach((title) => {
          const tr = document.createElement('tr');
          tr.style.borderWidth = 0;

          const th = document.createElement('th');
          th.style.borderWidth = 0;
          const text = document.createTextNode(title);

          th.appendChild(text);
          tr.appendChild(th);
          tableHead.appendChild(tr);
        });

        const tableBody = document.createElement('tbody');
        bodyLines.forEach((body, i) => {
          const colors = tooltip.labelColors[i];

          const span = document.createElement('span');
          span.style.background = colors.backgroundColor;
          span.style.borderColor = colors.borderColor;
          span.style.borderWidth = '2px';
          span.style.marginRight = '10px';
          span.style.height = '10px';
          span.style.width = '10px';
          span.style.display = 'inline-block';

          const tr = document.createElement('tr');
          tr.style.backgroundColor = 'inherit';
          tr.style.borderWidth = 0;

          const td = document.createElement('td');
          td.style.borderWidth = 0;

          const text = document.createTextNode(body);

          td.appendChild(span);
          td.appendChild(text);
          tr.appendChild(td);
          tableBody.appendChild(tr);
        });

        const tableRoot = tooltipEl.querySelector('table');

        tableRoot.style.display = 'inline-block';
        tableRoot.style.whiteSpace = 'nowrap';

        // Remove old children
        while (tableRoot.firstChild) {
          tableRoot.firstChild.remove();
        }

        // Add new children
        tableRoot.appendChild(tableHead);
        tableRoot.appendChild(tableBody);
      }

      const { offsetLeft: positionX, offsetTop: positionY } = chart.canvas;

      // Display, position, and set styles for font
      tooltipEl.style.opacity = 1;
      tooltipEl.style.left = `${positionX + tooltip.caretX}px`;
      tooltipEl.style.top = `${positionY + tooltip.caretY}px`;
      tooltipEl.style.font = tooltip.options.bodyFont.string;
      tooltipEl.style.padding = `${tooltip.options.padding}px ${tooltip.options.padding}px`;
    };

    const config = {
      type: 'pie',
      data: {
        labels: LabelResult,
        datasets: [
          {
            data: DataResult,
            backgroundColor: ['#3f34b2', '#7435FE', '#ada5ff', '#fec735'],
            borderWidth: 0,
          },
        ],
      },
      options: {
        plugins: {
          tooltip: {
            enabled: false,
            position: 'nearest',
            external: externalTooltipHandler,
            yalign: 'top'
          },
          legend: {
            display: false,
          },
        },
      },
    };

    const ctx = this.pieChart.getContext('2d');
    this.chart = new Chart(ctx, config);
  }

  render() {
    return (
      <div className="pie_chart_wrap">
        <canvas
          className="pie_chart"
          ref={(ref) => { this.pieChart = ref; }}
        />
      </div>
    );
  }
}

export default PieChart2;
